export default {"src":"/_next/static/media/matching.be2dc7db.svg","height":102,"width":102,"blurWidth":0,"blurHeight":0};